export interface GenerateCodeRequest {
  OtpType: GenerateCodeTypes;
}

export enum GenerateCodeTypes {
  CreateTransferRequest = 'CreateTransferRequest',
  UpdateTransferRequest = 'UpdateTransferRequest',
}
